import { Badge, Button, styled } from '@mui/material';

export const Wrapper = styled('div')`
  position: relative;
`;

export const StyledBtn = styled(Button)`
  height: 44px;
  width: 44px;
  min-width: unset;
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.info.light};
`;

export const BadgeW = styled(Badge)`
  & .MuiBadge-badge {
    background-color: ${({ theme }) => theme.palette.info.main};
    min-width: 11px;
    width: 11px;
    height: 11px;
    top: 5px;
    right: 5px;
  }
`;
